(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-slideshow"] && !Shopify.designMode) return;
  try {
     
jQuery(document).ready($ => {
$('.about-carousel').owlCarousel({ 
  loop:true,
  autoplay: true, 
  margin:0, 
  nav:true, 
  navSpeed: 500,
  navText: ["<i class='icon-chevron-left'></i>","<i class='icon-chevron-right'></i>"], 
  dots: false, 
  items: 1, 
  center: true,
  animateOut: "fadeOut",
}) 
}) 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-filter"] && !Shopify.designMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uvp-modal"] && !Shopify.designMode) return;
  try {
    
  $('.uvp-learnmore').click(function(e) {
    e.preventDefault();
    const id = $(this).attr('id');
    $('#' + id + '-modal').show();
    $('.uvp-modal-bg').show();
  });
  $('.uvp-modal-bg, .modal-close').click(function(e) {
    e.preventDefault();
    $('.uvp-modal').hide();
     $('.uvp-modal-bg').hide();
  });

  if ($(window).width() < 767) {
    beginSlideshow();
    
  }
  function beginSlideshow() {
    $(document).ready(function() {
    // Set Basic variables
    var slides = $('.uvp-item');
    var slideIndex = 0;
    
    // Show the first slide
    $(slides[slideIndex]).show();
    
    // Set interval to change slides
    setInterval(function() {
      // Hide the current slide
      $(slides[slideIndex]).fadeOut();
      
      // Increment index or reset to 0
     slideIndex = (slideIndex + 1) % slides.length;
      
      // Show the next slide
      $(slides[slideIndex]).fadeIn();
    }, 5000); 
  });
  }

  } catch(e) { console.error(e); }
})();
})();
